<template>
    <div>
        <Row :gutter="16">
            <Col span="18">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row :gutter="16">
                        <Col span="24">
                            <Form :model="formItem" :rules="ruleValidate" :label-width="100" label-position="right"
                                  :loading="loading" ref="form">
                                <FormItem :label="t.role.name" prop="name">
                                    <Input v-model="formItem.name" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.role.name)"></Input>
                                </FormItem>
                                <FormItem :label="t.role.code" prop="code">
                                    <Input v-model="formItem.code" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.role.code)"></Input>
                                </FormItem>
                                <FormItem :label="t.role.sortOrder" prop="sortOrder">
                                    <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.role.status" prop="status">
                                    <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.role.open}}</span>
                                        <span slot="close">{{t.role.close}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem :label="t.role.remark" prop="remark">
                                    <Input v-model="formItem.remark" :maxlength="200"
                                           :placeholder="msgUtil.placeholderRequired(t.role.remark)"
                                           type="textarea"></Input>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="6">
                <Card>
                    <p slot="title">
                        <Icon type="logo-buffer"/>
                        {{t.menu.menuDistribute}}
                    </p>
                    <P style="padding-left:20px;height: 360px;overflow-x: auto;">
                        <Tree ref="tree" show-checkbox :data="menuList"></Tree>
                    </P>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { getTreeMenuList } from '@/api/menu';
import { edit, getRoleInfo } from '@/api/role';

export default {
    name: 'organization_role_edit',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            t: t,
            msgUtil: msgUtil,
            formItemBk: {},
            formItem: {
                name: '',
                status: '0',
                code: '',
                sortOrder: 0,
                menuIdList: [],
                remark: '',
            },
            //所有的后台权限菜单列
            menuIdListBK: [],
            menuList: [],
            loading: false,
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.role.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.role.name, 32),
                        trigger: 'blur',
                    },
                ],
                authority: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.role.authority),
                        trigger: 'change',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.role.code),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.role.code, 32),
                        trigger: 'blur',
                    },
                ],
                sortOrder: [
                    {
                        required: true,
                        type: 'number',
                        message: msgUtil.errorRequired(t.role.sortOrder),
                        trigger: 'blur',
                    },
                ],
                remark: [
                    {
                        type: 'string',
                        max: 200,
                        message: msgUtil.errorMaxLengthFullWidth(t.role.remark, 200),
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    let roleDto = {};
                    roleDto.name = this.formItem.name;
                    roleDto.status = this.formItem.status;
                    roleDto.code = this.formItem.code;
                    roleDto.sortOrder = this.formItem.sortOrder;
                    roleDto.remark = this.formItem.remark;
                    roleDto.menuIdList = this.$refs.tree.getCheckedAndIndeterminateNodes().map(p => p.id);
                    const res = await edit(this.$route.params.id, roleDto);
                    Object.assign(this.formItemBk, this.formItem);
                    this.menuIdListBK = this.formItem.menuIdList;
                    this.$Loading.finish();
                    this.$Message.success(this.msgUtil.message.action.updateSuccess);
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.updateFail);
                }
            });
            this.loading = false;
        },
        async handleReset() {
            this.$refs.form.resetFields();
            Object.assign(this.formItem, this.formItemBk);
            this.formItem.menuIdList = this.menuIdListBK;
            this.serSelectedForMenuIdList(this.menuList);
            this.loading = false;
        },
        //被选中的角色权限匹配映射
        serSelectedForMenuIdList(nodeElement) {
            for (let i = 0; i < nodeElement.length; i++) {
                if (nodeElement[i].children.length > 0) {
                    this.serSelectedForMenuIdList(nodeElement[i].children);
                    continue;
                } else {
                    nodeElement[i] = { title: nodeElement[i].title, id: nodeElement[i].id };
                }
                if (this.formItem.menuIdList.includes(nodeElement[i].id)) {
                    nodeElement[i].checked = true;
                }
            }
        },
        async init() {
            const roleInfo = await getRoleInfo(this.$route.params.id);

            if (roleInfo.role != null) {
                this.formItem = roleInfo.role;
                //得到后台所有菜单展示
                const menuList = await getTreeMenuList({ division: 2 });
                if (menuList.menus != null) {
                    this.menuList = menuList.menus;
                    //被选中的角色权限匹配映射
                    this.serSelectedForMenuIdList(this.menuList);
                    this.menuIdListBK = this.$refs.tree.getCheckedAndIndeterminateNodes().map(p => p.id);
                }
                Object.assign(this.formItemBk, roleInfo.role);
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
